import { defineStore } from 'pinia';

export const usePermission = defineStore('app-permission', {
  state: () => ({
    btnPermissions: null,
    // routers中所有菜单项被flatted
    menuPermissions: null,
    // routers原数据
    routerPermissions: null,
    showNoNet: false,
    toHome: null
  }),
  actions: {
    setNoNetState (val) {
      this.showNoNet = val;
    }
  }
});
